import React from "react";
import "../styles/thankyou.css";
import { Link } from "react-router-dom";

export default function ThankYou() {
  return (
    <div className='container '>
      <div className='d-flex'>
        <header>Payments powered by Ayoba</header>{" "}
        <Link to='/' className='home-link'>
          <span>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='16'
              height='16'
              fill='currentColor'
              class='bi bi-arrow-left-square-fill'
              viewBox='0 0 16 16'
            >
              <path d='M16 14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2zm-4.5-6.5H5.707l2.147-2.146a.5.5 0 1 0-.708-.708l-3 3a.5.5 0 0 0 0 .708l3 3a.5.5 0 0 0 .708-.708L5.707 8.5H11.5a.5.5 0 0 0 0-1' />
            </svg>
          </span>
        </Link>
      </div>

      <div className='image-container'>
        <img src={process.env.PUBLIC_URL + "/ayoba-logo.svg"} alt='Icon' />

        <p className='gratitude'>
          Thank You! <br />
          For your donation
        </p>

        <h4>Ayoba donation app</h4>
        <small>Empowering change through action</small>
      </div>
    </div>
  );
}
